/**
 * Circadian Color Mode System for Shopify
 * 
 * This script automatically adjusts the website's color scheme based on:
 * 1. Current time of day (dawn, day, dusk, night)
 * 2. Current season in New Zealand
 * 3. Smooth transitions between color modes
 */

// Self-executing function to avoid global namespace pollution
// (function() {
//   // Configuration for seasonal transition times (New Zealand)
//   const SEASONAL_TIMES = {
//     summer: {
//       dawn: { start: 5 * 60, end: 7 * 60 }, // 5:00 AM to 7:00 AM
//       day: { start: 7 * 60, end: 20 * 60 }, // 7:00 AM to 8:00 PM
//       dusk: { start: 20 * 60, end: 21.5 * 60 }, // 8:00 PM to 9:30 PM
//       night: { start: 21.5 * 60, end: 5 * 60 } // 9:30 PM to 5:00 AM (next day)
//     },
//     autumn: {
//       dawn: { start: 6 * 60, end: 8 * 60 }, // 6:00 AM to 8:00 AM
//       day: { start: 8 * 60, end: 18 * 60 }, // 8:00 AM to 6:00 PM
//       dusk: { start: 18 * 60, end: 19.5 * 60 }, // 6:00 PM to 7:30 PM
//       night: { start: 19.5 * 60, end: 6 * 60 } // 7:30 PM to 6:00 AM (next day)
//     },
//     winter: {
//       dawn: { start: 7 * 60, end: 9 * 60 }, // 7:00 AM to 9:00 AM
//       day: { start: 9 * 60, end: 17 * 60 }, // 9:00 AM to 5:00 PM
//       dusk: { start: 17 * 60, end: 18.5 * 60 }, // 5:00 PM to 6:30 PM
//       night: { start: 18.5 * 60, end: 7 * 60 } // 6:30 PM to 7:00 AM (next day)
//     },
//     spring: {
//       dawn: { start: 6 * 60, end: 8 * 60 }, // 6:00 AM to 8:00 AM
//       day: { start: 8 * 60, end: 18.5 * 60 }, // 8:00 AM to 6:30 PM
//       dusk: { start: 18.5 * 60, end: 20 * 60 }, // 6:30 PM to 8:00 PM
//       night: { start: 20 * 60, end: 6 * 60 } // 8:00 PM to 6:00 AM (next day)
//     }
//   };

//   // Color mode classes to be applied to the body
//   const COLOR_MODES = ['dawn', 'day', 'dusk', 'night'];
  
//   // Duration of transition in minutes
//   const TRANSITION_DURATION = 60;

//   /**
//    * Determines the current season in New Zealand
//    * @returns {string} - 'summer', 'autumn', 'winter', or 'spring'
//    */
//   function getCurrentSeason() {
//     const now = new Date();
//     const month = now.getMonth() + 1; // JavaScript months are 0-indexed
    
//     if (month >= 12 || month <= 2) {
//       return 'summer';
//     } else if (month >= 3 && month <= 5) {
//       return 'autumn';
//     } else if (month >= 6 && month <= 8) {
//       return 'winter';
//     } else {
//       return 'spring';
//     }
//   }

//   /**
//    * Converts current time to minutes since midnight
//    * @returns {number} - Current time in minutes (0-1439)
//    */
//   function getCurrentTimeInMinutes() {
//     const now = new Date();
//     return now.getHours() * 60 + now.getMinutes();
//   }

//   /**
//    * Determines the current color mode and transition percentage
//    * @param {string} season - Current season
//    * @param {number} currentTimeMinutes - Current time in minutes
//    * @returns {object} - { currentMode, nextMode, transitionPercent }
//    */
//   function determineColorMode(season, currentTimeMinutes) {
//     const times = SEASONAL_TIMES[season];
    
//     // Handle special case for night which wraps around midnight
//     if (times.night.start <= currentTimeMinutes || currentTimeMinutes < times.dawn.start) {
//       // We're in night mode
//       const isBeforeMidnight = times.night.start <= currentTimeMinutes;
//       const nightDuration = isBeforeMidnight 
//         ? (24 * 60 - times.night.start) + times.dawn.start 
//         : times.dawn.start - times.night.end;
      
//       // Calculate transition to dawn if within transition period
//       const minutesToDawn = isBeforeMidnight
//         ? (24 * 60 - currentTimeMinutes) + times.dawn.start
//         : times.dawn.start - currentTimeMinutes;
        
//       if (minutesToDawn <= TRANSITION_DURATION) {
//         return {
//           currentMode: 'night',
//           nextMode: 'dawn',
//           transitionPercent: 100 - (minutesToDawn / TRANSITION_DURATION * 100)
//         };
//       }
      
//       return { 
//         currentMode: 'night', 
//         nextMode: null, 
//         transitionPercent: 0 
//       };
//     }
    
//     // Check each time period
//     if (currentTimeMinutes >= times.dawn.start && currentTimeMinutes < times.day.start) {
//       // Dawn period
//       const minutesToDay = times.day.start - currentTimeMinutes;
//       if (minutesToDay <= TRANSITION_DURATION) {
//         return {
//           currentMode: 'dawn',
//           nextMode: 'day',
//           transitionPercent: 100 - (minutesToDay / TRANSITION_DURATION * 100)
//         };
//       }
//       return { 
//         currentMode: 'dawn', 
//         nextMode: null, 
//         transitionPercent: 0 
//       };
//     } 
    
//     if (currentTimeMinutes >= times.day.start && currentTimeMinutes < times.dusk.start) {
//       // Day period
//       const minutesToDusk = times.dusk.start - currentTimeMinutes;
//       if (minutesToDusk <= TRANSITION_DURATION) {
//         return {
//           currentMode: 'day',
//           nextMode: 'dusk',
//           transitionPercent: 100 - (minutesToDusk / TRANSITION_DURATION * 100)
//         };
//       }
//       return { 
//         currentMode: 'day', 
//         nextMode: null, 
//         transitionPercent: 0 
//       };
//     } 
    
//     if (currentTimeMinutes >= times.dusk.start && currentTimeMinutes < times.night.start) {
//       // Dusk period
//       const minutesToNight = times.night.start - currentTimeMinutes;
//       if (minutesToNight <= TRANSITION_DURATION) {
//         return {
//           currentMode: 'dusk',
//           nextMode: 'night',
//           transitionPercent: 100 - (minutesToNight / TRANSITION_DURATION * 100)
//         };
//       }
//       return { 
//         currentMode: 'dusk', 
//         nextMode: null, 
//         transitionPercent: 0 
//       };
//     }
    
//     // Fallback (shouldn't reach here if logic is correct)
//     return { 
//       currentMode: 'day', 
//       nextMode: null, 
//       transitionPercent: 0 
//     };
//   }

//   /**
//    * Applies the color mode to the document by setting CSS variables
//    * @param {string} currentMode - Current color mode
//    * @param {string} nextMode - Next color mode (if in transition)
//    * @param {number} transitionPercent - Percentage of transition (0-100)
//    */
//   function applyColorMode(currentMode, nextMode, transitionPercent) {
//     // Clear any existing color mode classes
//     document.body.classList.remove(...COLOR_MODES.map(mode => `color-mode-${mode}`));
    
//     if (!nextMode || transitionPercent === 0) {
//       // Not in transition, just apply the current mode
//       document.body.classList.add(`color-mode-${currentMode}`);
//       document.body.style.setProperty('--color-mode-transition', '0');
//       return;
//     }
    
//     // We're in a transition between two modes
//     document.body.classList.add(`color-mode-${currentMode}`);
//     document.body.classList.add(`color-mode-${nextMode}`);
//     document.body.style.setProperty('--color-mode-transition', transitionPercent / 100);
    
//     // Get all CSS variables from both modes and interpolate between them
//     const computedStyle = getComputedStyle(document.documentElement);
//     const currentModeVars = {};
//     const nextModeVars = {};
    
//     // Store the document's style declarations for modification
//     const rootStyle = document.documentElement.style;
    
//     // This technique requires your CSS to be set up with variables for each mode
//     // For example: --color-bg-dawn, --color-bg-day, etc.
//     // We'll find all CSS variables and interpolate between matching pairs
    
//     // First, backup the current state by forcing the body to have only the current mode
//     document.body.classList.remove(`color-mode-${nextMode}`);
    
//     // Get all CSS variables from the current mode
//     for (const property of computedStyle) {
//       if (property.startsWith('--')) {
//         currentModeVars[property] = computedStyle.getPropertyValue(property).trim();
//       }
//     }
    
//     // Now check the next mode
//     document.body.classList.remove(`color-mode-${currentMode}`);
//     document.body.classList.add(`color-mode-${nextMode}`);
    
//     // Get all CSS variables from the next mode
//     for (const property of computedStyle) {
//       if (property.startsWith('--')) {
//         nextModeVars[property] = computedStyle.getPropertyValue(property).trim();
//       }
//     }
    
//     // Reset the classes
//     document.body.classList.remove(`color-mode-${nextMode}`);
//     document.body.classList.add(`color-mode-${currentMode}`);
    
//     // Now interpolate between the variables
//     for (const property in currentModeVars) {
//       if (nextModeVars[property]) {
//         const currentValue = currentModeVars[property];
//         const nextValue = nextModeVars[property];
        
//         // Handle color interpolation (assuming hex, rgb, or rgba)
//         if (currentValue.startsWith('#') || currentValue.startsWith('rgb')) {
//           try {
//             const interpolatedColor = interpolateColor(currentValue, nextValue, transitionPercent / 100);
//             rootStyle.setProperty(property, interpolatedColor);
//           } catch (e) {
//             // If color interpolation fails, just use the current value
//             rootStyle.setProperty(property, currentValue);
//           }
//         } 
//         // Handle numeric values with units
//         else if (!isNaN(parseFloat(currentValue))) {
//           const currentUnit = currentValue.replace(/[\d.-]/g, '');
//           const currentNumber = parseFloat(currentValue);
//           const nextNumber = parseFloat(nextValue);
          
//           const interpolatedValue = currentNumber + ((nextNumber - currentNumber) * (transitionPercent / 100));
//           rootStyle.setProperty(property, `${interpolatedValue}${currentUnit}`);
//         }
//         // For other values, just use a threshold approach
//         else if (transitionPercent > 50) {
//           rootStyle.setProperty(property, nextValue);
//         } else {
//           rootStyle.setProperty(property, currentValue);
//         }
//       }
//     }
//   }

//   /**
//    * Interpolates between two colors
//    * @param {string} color1 - Starting color (hex, rgb, or rgba)
//    * @param {string} color2 - Ending color (hex, rgb, or rgba)
//    * @param {number} factor - Interpolation factor (0-1)
//    * @returns {string} - Interpolated color
//    */
//   function interpolateColor(color1, color2, factor) {
//     // Convert to RGB arrays
//     const rgb1 = colorToRgb(color1);
//     const rgb2 = colorToRgb(color2);
    
//     // Check if either color has alpha
//     const hasAlpha = rgb1.length > 3 || rgb2.length > 3;
    
//     // Ensure both arrays have alpha values if needed
//     if (hasAlpha) {
//       if (rgb1.length === 3) rgb1.push(1);
//       if (rgb2.length === 3) rgb2.push(1);
//     }
    
//     // Interpolate each component
//     const result = [];
//     for (let i = 0; i < (hasAlpha ? 4 : 3); i++) {
//       result.push(Math.round(rgb1[i] + factor * (rgb2[i] - rgb1[i])));
//     }
    
//     // Convert back to CSS color string
//     if (hasAlpha) {
//       return `rgba(${result[0]}, ${result[1]}, ${result[2]}, ${result[3]})`;
//     } else {
//       return `rgb(${result[0]}, ${result[1]}, ${result[2]})`;
//     }
//   }

//   /**
//    * Converts any CSS color to RGB components
//    * @param {string} color - CSS color (hex, rgb, rgba)
//    * @returns {Array} - Array of RGB(A) values
//    */
//   function colorToRgb(color) {
//     // Create a hidden element to compute the color
//     const tempElement = document.createElement('div');
//     tempElement.style.color = color;
//     tempElement.style.display = 'none';
//     document.body.appendChild(tempElement);
    
//     // Get computed color
//     const computedColor = getComputedStyle(tempElement).color;
//     document.body.removeChild(tempElement);
    
//     // Parse the computed RGB(A) color
//     const match = computedColor.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)/);
    
//     if (match) {
//       const r = parseInt(match[1], 10);
//       const g = parseInt(match[2], 10);
//       const b = parseInt(match[3], 10);
//       const a = match[4] ? parseFloat(match[4]) : 1;
      
//       if (a < 1) {
//         return [r, g, b, a];
//       } else {
//         return [r, g, b];
//       }
//     }
    
//     // Fallback for unsupported colors
//     return [0, 0, 0];
//   }

//   /**
//    * Update color mode based on current time and season
//    */
//   function updateColorMode() {
//     const season = getCurrentSeason();
//     const currentTimeMinutes = getCurrentTimeInMinutes();
//     const { currentMode, nextMode, transitionPercent } = determineColorMode(season, currentTimeMinutes);
    
//     applyColorMode(currentMode, nextMode, transitionPercent);
    
//     // Log current state (can be removed in production)
//     console.log(`Current mode: ${currentMode}${nextMode ? ` → ${nextMode} (${transitionPercent.toFixed(1)}%)` : ''}`);
//   } 

//   /**
//    * Initialise the color mode system
//    */

//   function initColorModeSystem() {
//     // Add a data attribute to the body for potential CSS targeting
//     document.body.setAttribute('data-color-mode-enabled', 'true');
    
//     // Initial update
//     updateColorMode();
    
//     // Set up periodic updates (every minute)
//     setInterval(updateColorMode, 60000);
    
//     // Add a CSS transition for smoother visual changes
//     const style = document.createElement('style');
//     style.textContent = `
//       body[data-color-mode-enabled="true"] {
//         transition: background-color 2s ease, color 2s ease;
//       }
      
//       body[data-color-mode-enabled="true"] section {
//         transition: background-color 2s ease, color 2s ease, border-color 2s ease;
//       }
//     `;
//     document.head.appendChild(style);
//   }

//   function setupToggleButtons(selector = '.navbar-main__toggle', storageKey = 'buttonActive') {
//     const buttons = document.querySelectorAll(selector);
//     if (!buttons.length) return;

//     const isActive = localStorage.getItem(storageKey) === 'true';

//     buttons.forEach((button) => {
//       if (isActive) {
//         button.classList.add('active');
//       }
//     });

//     if (isActive) {
//       document.body.classList.add('color-mode-activated');
//       initColorModeSystem();
//     }

//     buttons.forEach((button) => {
//       button.addEventListener('click', () => {
//         const currentlyActive = button.classList.toggle('active');

//         // Toggle for all buttons to stay in sync
//         buttons.forEach(btn => btn.classList.toggle('active', currentlyActive));

//         document.body.classList.toggle('color-mode-activated', currentlyActive);
//         localStorage.setItem(storageKey, currentlyActive);

//         if (currentlyActive) {
//           initColorModeSystem();
//         } else {
//           location.reload(); // Optional
//         }
//       });
//     });
//   }


//   // Initialize when the DOM is ready
//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', () => setupToggleButtons('.navbar-main__toggle', 'themeMode'));
//   } else {
//     setupToggleButtons('.navbar-main__toggle', 'themeMode');
//   }
// })();


(function () {
  const COLOR_MODES = ['dawn', 'day', 'dusk', 'night'];
  const TRANSITION_DURATION = 60;
  const SEASONAL_TIMES = {
    summer: {
      dawn: { start: 5 * 60, end: 7 * 60 }, // 5:00 AM to 7:00 AM
      day: { start: 7 * 60, end: 20 * 60 }, // 7:00 AM to 8:00 PM
      dusk: { start: 20 * 60, end: 21.5 * 60 }, // 8:00 PM to 9:30 PM
      night: { start: 21.5 * 60, end: 5 * 60 } // 9:30 PM to 5:00 AM (next day)
    },
    autumn: {
      dawn: { start: 6 * 60, end: 8 * 60 }, // 6:00 AM to 8:00 AM
      day: { start: 8 * 60, end: 18 * 60 }, // 8:00 AM to 6:00 PM
      dusk: { start: 18 * 60, end: 19.5 * 60 }, // 6:00 PM to 7:30 PM
      night: { start: 19.5 * 60, end: 6 * 60 } // 7:30 PM to 6:00 AM (next day)
    },
    winter: {
      dawn: { start: 7 * 60, end: 9 * 60 }, // 7:00 AM to 9:00 AM
      day: { start: 9 * 60, end: 17 * 60 }, // 9:00 AM to 5:00 PM
      dusk: { start: 17 * 60, end: 18.5 * 60 }, // 5:00 PM to 6:30 PM
      night: { start: 18.5 * 60, end: 7 * 60 } // 6:30 PM to 7:00 AM (next day)
    },
    spring: {
      dawn: { start: 6 * 60, end: 8 * 60 }, // 6:00 AM to 8:00 AM
      day: { start: 8 * 60, end: 18.5 * 60 }, // 8:00 AM to 6:30 PM
      dusk: { start: 18.5 * 60, end: 20 * 60 }, // 6:30 PM to 8:00 PM
      night: { start: 20 * 60, end: 6 * 60 } // 8:00 PM to 6:00 AM (next day)
    }
  };

  function getCurrentSeason() {
    const m = new Date().getMonth() + 1;
    if (m >= 12 || m <= 2) return 'summer';
    if (m >= 3 && m <= 5) return 'autumn';
    if (m >= 6 && m <= 8) return 'winter';
    return 'spring';
  }

  function getCurrentTimeInMinutes() {
    const now = new Date();
    return now.getHours() * 60 + now.getMinutes();
  }

  function determineColorMode(season, now) {
    const t = SEASONAL_TIMES[season];
    if (t.night.start <= now || now < t.dawn.start) {
      const beforeMidnight = now >= t.night.start;
      const toDawn = beforeMidnight ? (1440 - now + t.dawn.start) : (t.dawn.start - now);
      if (toDawn <= TRANSITION_DURATION) return { currentMode: 'night', nextMode: 'dawn', transitionPercent: 100 - toDawn / TRANSITION_DURATION * 100 };
      return { currentMode: 'night', nextMode: null, transitionPercent: 0 };
    }
    for (const key of ['dawn', 'day', 'dusk']) {
      const next = key === 'dawn' ? 'day' : key === 'day' ? 'dusk' : 'night';
      const period = t[key];
      if (now >= period.start && now < period.end) {
        const toNext = period.end - now;
        if (toNext <= TRANSITION_DURATION) return { currentMode: key, nextMode: next, transitionPercent: 100 - toNext / TRANSITION_DURATION * 100 };
        return { currentMode: key, nextMode: null, transitionPercent: 0 };
      }
    }
    return { currentMode: 'day', nextMode: null, transitionPercent: 0 };
  }

  function applyColorMode(currentMode, nextMode, transitionPercent) {
    document.body.classList.remove(...COLOR_MODES.map(mode => `color-mode-${mode}`));
    if (!nextMode || transitionPercent === 0) {
      document.body.classList.add(`color-mode-${currentMode}`);
      document.body.style.setProperty('--color-mode-transition', '0');
    } else {
      document.body.classList.add(`color-mode-${currentMode}`, `color-mode-${nextMode}`);
      document.body.style.setProperty('--color-mode-transition', transitionPercent / 100);
    }
  }

  function updateColorMode() {
    const { currentMode, nextMode, transitionPercent } = determineColorMode(getCurrentSeason(), getCurrentTimeInMinutes());
    applyColorMode(currentMode, nextMode, transitionPercent);
    console.log(currentMode,'sds')
    const modes = window.buttonBlockData;
    let dayIcon = null;
    for (const key in modes) {
      const item = modes[key];
      if (item.label && item.label.toLowerCase() === currentMode) {
        dayIcon = item.icon;
        break;
      }
    }
    if (dayIcon) {
      const imgEl = document.querySelector('.circadian-tooltip__icon img');
      if (imgEl) {
        imgEl.src = dayIcon;
      }
    }
    document.querySelector('.circadian-tooltip__timezone').textContent = currentMode;
  }

  let autoModeIntervalId = null;

  function initColorModeSystem() {
    if (autoModeIntervalId) clearInterval(autoModeIntervalId);
    document.body.setAttribute('data-color-mode-enabled', 'true');
    updateColorMode();
    setInterval(updateColorMode, 60000);
    window.autoColorModeActive = true; // Mark auto mode as active
    const style = document.createElement('style');
    style.textContent = `
      body[data-color-mode-enabled="true"],
      body[data-color-mode-enabled="true"] section {
        transition: background-color 2s ease, color 2s ease, border-color 2s ease;
      }`;
    document.head.appendChild(style);
  }

  function stopAutoColorMode() {
    if (autoModeIntervalId) {
      clearInterval(autoModeIntervalId);
      autoModeIntervalId = null;
    }
    window.autoColorModeActive = false;
  }


  function setupToggleButtons(selector = '.navbar-main__toggle', storageKey = 'themeMode') {
  const buttons = document.querySelectorAll(selector);
  if (!buttons.length) return;

  const isActive = localStorage.getItem(storageKey) === 'true';
  const autoTooltip = document.querySelector('[data-mode="automatic-selection"]');

  buttons.forEach(button => {
    button.classList.toggle('active', isActive);
    autoTooltip.classList.toggle('active', isActive);
  });

  

  buttons.forEach(button => {
    button.addEventListener('click', () => {
      const currentlyActive = button.classList.toggle('active');
      buttons.forEach(btn => btn.classList.toggle('active', currentlyActive));
      document.querySelectorAll('.circadian-tooltip__button').forEach(t => t.classList.remove('active'));
      autoTooltip.classList.toggle('active', currentlyActive);
      document.body.classList.toggle('color-mode-activated', currentlyActive);
      localStorage.setItem(storageKey, currentlyActive);

      if (currentlyActive) {
        localStorage.setItem('savedCircadianClass', 'automatic-selection');
        // initColorModeSystem();
        updateColorMode()
      } else {
        localStorage.removeItem('savedCircadianClass');
        location.reload(); // fallback reset
      }
    });
  });
}


  document.addEventListener('DOMContentLoaded', function () {
    setupToggleButtons('.navbar-main__toggle', 'themeMode');

    const popup = document.querySelector('.circadian-tooltip');
    const closeBtn = document.querySelector('.circadian-tooltip__close');
    const wrapper = document.querySelector('.circadian-tooltip__wrapper');
    const hasVisited = localStorage.getItem('hasSeenCircadianPopup');
    const savedThemeClass = localStorage.getItem('savedCircadianClass');
    const hasButtonActive = localStorage.getItem('buttonActive');

    const clearSessionKey = (key = 'pageLoaded') => sessionStorage.removeItem(key);

    if (savedThemeClass === 'automatic-selection') {
      localStorage.setItem('buttonActive', 'true');
      document.body.setAttribute('data-color-mode-enabled', 'true');
      document.body.classList.add('color-mode-activated');
      document.querySelectorAll('.circadian-tooltip__button').forEach(btn => {
      document.querySelectorAll('.navbar-main__toggle').forEach(t => t.classList.add('active'));
        if (btn.dataset.mode === savedThemeClass) {
          btn.classList.add('active');
          renderTooltip(btn.dataset.blockId);
        } else {
          btn.classList.remove('active');
        }
      });
      initColorModeSystem();
    } else if (savedThemeClass && hasButtonActive === 'true') {
      document.body.classList.add('color-mode-activated', savedThemeClass);
      document.body.setAttribute('data-color-mode-enabled', 'true');
      document.querySelectorAll('.circadian-tooltip__button').forEach(btn => {
        if (btn.dataset.mode === savedThemeClass) {
          btn.classList.add('active');
          renderTooltip(btn.dataset.blockId);
        } else {
          btn.classList.remove('active');
        }
      });
    } else {
      localStorage.setItem('buttonActive', 'false');
      if (!hasVisited && popup) {
        setTimeout(() => document.body.classList.add('circadian-tooltip--show'), 5000);
      }
    }

    function renderTooltip(blockId) {
      const data = window.buttonBlockData?.[blockId];
      if (!data) return;

      document.querySelector('.circadian-tooltip__description').innerHTML = data.description;
      document.querySelector('.circadian-tooltip__timezone').textContent = data.label;
      document.querySelector('.circadian-tooltip__iconbox p').textContent = data.mode_caption;
      document.querySelector('.canvas-animated__bg').style.backgroundColor = data.color_background;

      const modeIcon = document.querySelector('.circadian-tooltip__icon img');
      const label = document.querySelector('.circadian-tooltip__timezone');
      const tooltip = document.querySelector('.circadian-tooltip__iconbox p');
      const dataLabel = data.label.toLowerCase();

      if (dataLabel !== 'auto') {
        modeIcon.src = data.icon;
        Object.values(window.buttonBlockData).forEach(item => item.classes && document.body.classList.remove(item.classes));
      }

      if (dataLabel === 'off') {
        localStorage.removeItem('savedCircadianClass');
        document.body.removeAttribute('data-color-mode-enabled');
        document.body.classList.remove('color-mode-activated');
        localStorage.setItem('buttonActive', 'false');
        localStorage.setItem('themeMode', 'false');
        document.querySelectorAll('.navbar-main__toggle').forEach(t => t.classList.remove('active'));
      } else {
        localStorage.setItem('themeMode', 'true');
        document.querySelectorAll('.navbar-main__toggle').forEach(t => t.classList.add('active'));
        if (data.classes) {
          document.body.classList.add('color-mode-activated', data.classes);
          document.body.setAttribute('data-color-mode-enabled', 'true');
          localStorage.setItem('savedCircadianClass', data.classes);
        }
        localStorage.setItem('buttonActive', 'true');
      }

      const colors = { morning: '#FFE5B4', evening: '#FFD580' };
      const color = colors[dataLabel] || '#FFFFFF';
      label.style.color = color;
      tooltip.style.color = color;
    }

    document.querySelectorAll('.circadian-tooltip__button').forEach(btn => {
      btn.addEventListener('click', function () {
        document.querySelectorAll('.circadian-tooltip__button').forEach(b => b.classList.remove('active'));
        this.classList.add('active');
        renderTooltip(this.dataset.blockId);
        localStorage.setItem('hasSeenCircadianPopup', 'true');
        window.location.reload();
        setTimeout(function(){
          document.body.classList.remove('circadian-tooltip--show');
        },600);
        clearSessionKey();
        


        if (this.dataset.mode === 'automatic-selection') {
          stopAutoColorMode();
          localStorage.setItem('savedCircadianClass', 'automatic-selection');
          window.location.reload(); // triggers auto theme next load
        } else if (this.dataset.mode === '') {
          stopAutoColorMode(); // ✅ Stop the auto mode loop
          document.body.removeAttribute('data-color-mode-enabled');
          window.autoColorModeActive = false;
          document.querySelectorAll('.navbar-main__toggle').forEach(t => t.classList.remove('active'));
        }
      });
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        document.body.classList.remove('circadian-tooltip--show');
        localStorage.setItem('hasSeenCircadianPopup', 'true');
      });
    }

    document.addEventListener('click', function (event) {
      if (
        document.body.classList.contains('circadian-tooltip--show') &&
        !wrapper.contains(event.target) &&
        !event.target.closest('.circadian-tooltip__button') &&
        !event.target.closest('.navbar-main__timer')
      ) {
        document.body.classList.remove('circadian-tooltip--show');
        localStorage.setItem('hasSeenCircadianPopup', 'true');
      }
    });

      const triggers = document.querySelectorAll('.navbar-main__timer');
      if (!triggers.length) return;

      triggers.forEach(trigger => {
        trigger.addEventListener('click', () => {
          document.body.classList.toggle('circadian-tooltip--show');
        });
      });

  });
})();
